import { Link } from "react-router-dom";
import { FaLinkedin, FaGithub, FaTwitter } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-[#040714] to-[#0a1930] text-white relative overflow-hidden">
      {/* Background Pattern remains the same */}
      
      <div className="container mx-auto px-4 pt-16 pb-8 relative">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Company Info */}
          <div className="space-y-6 text-center md:text-left">
            <img src="/images/logo-dark.png" alt="Logo" className="h-6 md:h-8 block mx-auto md:mx-0" />
            <p className="text-gray-300 leading-relaxed">
              Transforming ideas into digital reality through innovative IT solutions.
            </p>
            <div className="flex space-x-4 justify-center md:justify-start">
              <Link 
                to="#" 
                className="bg-white/10 w-10 h-10 p-2 rounded-full hover:bg-white/20 transform hover:scale-110 transition-all duration-300 flex items-center justify-center"
              >
                <FaLinkedin size={20} />
              </Link>
              {/* <Link 
                to="#" 
                className="bg-white/10 p-2 rounded-full hover:bg-white/20 transform hover:scale-110 transition-all duration-300"
              >
                <FaGithub size={20} />
              </Link> */}
              {/* twitter link */}
              <Link 
                to="#" 
                className="bg-white/10 w-10 h-10 p-2 rounded-full hover:bg-white/20 transform hover:scale-110 transition-all duration-300 flex items-center justify-center"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1200 1227" fill="none">
                  <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H339.688L731.801 515.685L779.269 583.579L1200 1150.22H1004.33L569.165 687.854V687.828Z" fill="currentColor"/>
                </svg>
              </Link>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4 text-center md:text-left">
            <h4 className="text-lg font-semibold text-[#17A2B8]">Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services/web-development" className="text-white/80 hover:text-white transition-colors">Web Development</Link></li>
              <li><Link to="/services/mobile-apps" className="text-white/80 hover:text-white transition-colors">Mobile Apps</Link></li>
              <li><Link to="/services/cloud-solutions" className="text-white/80 hover:text-white transition-colors">Cloud Solutions</Link></li>
              <li><Link to="/services/consulting" className="text-white/80 hover:text-white transition-colors">IT Consulting</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="space-y-4 text-center md:text-left">
            <h4 className="text-lg font-semibold text-[#17A2B8]">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-white/80 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/portfolio" className="text-white/80 hover:text-white transition-colors">Portfolio</Link></li>
              {/* <li><Link to="/careers" className="text-white/80 hover:text-white transition-colors">Careers</Link></li> */}
              <li><Link to="/contact" className="text-white/80 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4 text-center md:text-left">
            <h4 className="text-lg font-semibold text-[#17A2B8]">Contact Us</h4>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-center space-x-2 hover:text-white transition-colors justify-center md:justify-start">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin-icon lucide-map-pin w-4 h-4"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/></svg>
                </span>
                <span className="ms-1">Ichalkaranji, Maharashtra</span>
              </li>
              <li className="flex items-center space-x-2 hover:text-white transition-colors justify-center md:justify-start">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-phone-icon lucide-phone w-4 h-4"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"/></svg>
                </span>
                <span className="ms-1">(+91) 8888216196</span>
              </li>
              <li className="flex items-center space-x-2 hover:text-white transition-colors justify-center md:justify-start">
                <span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mail-icon lucide-mail w-4 h-4"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"/><rect x="2" y="4" width="20" height="16" rx="2"/></svg>
                </span>
                <span className="ms-1">info@asciibytes.in</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            <span>&copy; {new Date().getFullYear()} ASCIIBytes. All rights reserved.</span>
            <span className="mx-2 hidden sm:inline-block">|</span>
            <span className="block sm:inline-block mt-2 sm:mt-0">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
              <span className="mx-2">|</span>
              <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}